import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "expanded" }
const _hoisted_2 = { class: "expanded-row" }
const _hoisted_3 = { class: "centered-column" }
const _hoisted_4 = {
  key: 0,
  class: "success"
}
const _hoisted_5 = {
  key: 1,
  class: "fail"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "expanded-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isSuccess)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "check" }, null, -1)
            ])))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[2] || (_cache[2] = [
              _createElementVNode("div", { class: "cross" }, null, -1),
              _createElementVNode("div", { class: "cross" }, null, -1)
            ]))),
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t(_ctx.isSuccess ? 'processEvent.voucher.message.success' : 'processEvent.voucher.message.failure')), 1),
        (_ctx.isSuccess)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_6, _toDisplayString(_ctx.$t('processEvent.voucher.message.success_extra', { amount: _ctx.amount, phoneNumber: _ctx.phoneNumber })), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        class: "submit-order",
        type: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showVoucher && _ctx.showVoucher(...args)))
      }, _toDisplayString(_ctx.$t(_ctx.isSuccess ? 'processEvent.voucher.btn.success' : 'processEvent.voucher.btn.failure')), 1)
    ])
  ]))
}